import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../core/service/auth.service';

@Component({
    selector: 'app-venta-selector',
    template: `
        <div class="form-group row" style="margin-bottom:0 !important;">
            <label for="activeSale" class="col-3 col-form-label">Campaign</label>
            <div class="col-9">
                <select name="activeSale" class="form-control" (change)="changeValue()">
                    <option [value]="s.pk" *ngFor="let s of sales">({{s.portal}}) {{s.name}} [{{s.type}}]</option>
                </select>
            </div>
        </div>
    `,
    styles: []
})
export class VentaSelectorComponent implements OnInit {

    public sales: Array<Object> = [];

    constructor(private auth: AuthService) {
        this.sales = auth.getSales();
    }

    ngOnInit() {
    }

    changeValue() {
    }
}


// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/config/components/venta-selector/venta-selector.component.ts